export default function Button({
  type = 'button',
  size = 'md',
  className = '',
  children,
  ...props
}) {
  const sizeClassName =
    size === 'lg'
      ? 'px-12 py-3.5 text-[19px]'
      : 'px-10 py-3 text-[17px]';

  return (
    <button
      type={type}
      className={`inline-flex h-fit w-fit items-center justify-center rounded-full bg-gradient-to-r from-button_transition_1 via-button_transition_2 to-button_transition_1 bg-size-200 bg-pos-0 font-bold text-white transition-all duration-500 hover:bg-pos-100 disabled:cursor-not-allowed disabled:opacity-60 disabled:hover:bg-pos-0 ${sizeClassName} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
